/** @file       Profile.css
 *  @author     Alex Huctwith <alex@kingsds.network>
 *              Danny Akbarzadeh <danny@kingsds.network>
 *
 *  @date       July 2022
 *
 *              Styling related to Profile component
 */

#user-profile .form-row:nth-child(3) .inlineinput:not(:first-child) {
  min-width: 13%;
  max-width: 13%;
}

@media
only screen and (max-width: 1000px){

  #profile-save {
    margin-top: 3%;
  }

}

@media only screen and (max-width: 480px) {
  #user-profile .form-row:nth-child(3) .inlineinput:not(:first-child){
    min-width: 100%;
    max-width: initial;
  }
}
